<strategy-lss-v1 [params]="params" *ngIf="strategy_name == 'lss_v1'"></strategy-lss-v1>
<strategy-orb-v1 [params]="params" *ngIf="strategy_name == 'orb_v1'"></strategy-orb-v1>